<template>
  <section class="share">
    <article class="share-main"
      :class="{'share-main-disable':isMain === false,'share-main-back': isMain === false, 'share-vip': modelIds === -4 && isMain}">
      <div class="share-main-icon"></div>

      <div class="share-standby" v-if="isMain === false && code !== 201">
        <div class="user-info">
          <img :src="mainPerson.profileUrl" width="36px" height="36px">
          <span>{{mainPerson.nickName}}</span>
        </div>
        <p class="tip">送你一张专属神券，速领，手慢无！</p>
      </div>
      <div class="share-standby" v-else-if="isMain === false && code === 201">
        <p class="big-tip">领取成功</p>
        <p class="tip big-line">优惠券已到账，</p>
        <p class="tip big-line">可在我的-优惠券查看</p>
      </div>

      <div class="share-coupon" :class="{'share-coupon-back':isMain === false}" v-show="code != 402">
        <div v-if="isMain === true" class="share-top-box">
          <p class="share-invitenum-tip" >
            <template v-if="!this.isCmc">
              <span v-if="modelIds === -4 && !isVip">开卡并</span>喊<span class="red">{{sharePersonCount}}位</span>好友即可领券
            </template>
            <template v-else>
              <span style="color:#666;">邀请<span class="red">{{sharePersonCount}}位</span>好友即可领券</span>
            </template>
          </p>
          <span :class="[!this.isCmc ? 'share-rule' : 'share-rule-cmc']" @click="openRule">规则</span>
        </div>

        <div class="share-coupon-box">
          <!-- 优惠券状态标 -->
          <div class="coupon-get-icon">
            <img v-if="isGet" src="@/assets/img/get-tip.png"
              srcset="@/assets/img/get-tip@2x.png 2x,@/assets/img/get-tip@3x.png 3x">
            <img v-else-if="prize.prizeEndTime < Date.now()" src="@/assets/img/over-tip.png"
              srcset="@/assets/img/over-tip@2x.png 2x,@/assets/img/over-tip@3x.png 3x">
            <img v-else-if="isMain === false && childCouponRate === 0" src="@/assets/img/nothing-tip.png"
              srcset="@/assets/img/nothing-tip@2x.png 2x,@/assets/img/nothing-tip@3x.png 3x">
            <img v-else src="@/assets/img/ready-tip.png"
              srcset="@/assets/img/ready-tip@2x.png 2x,@/assets/img/ready-tip@3x.png 3x">
          </div>

          <div class="coupon-trangle left"></div>
          <div class="coupon-trangle right"></div>
          <template v-if="!isCmc">
            <img v-if="!!pictureLink" :src="`//img14.360buyimg.com/${pictureLink}`" alt="店铺logo" class="share-shop-logo has-logo">
            <img v-else src="@/assets/img/coupon-logo.png" srcset="@/assets/img/coupon-logo@2x.png 2x,@/assets/img/coupon-logo@3x.png 3x" alt="券" class="share-shop-logo">
          </template>
          <template v-else>
            <div class="coupon-cmc">
              <div class="coupon-cmcLeft">
                <span class="coupon-cmcLeft-discount">
                  <span>¥</span>{{ prize.discount }}</span>
              </div>
              <div class="coupon-cmcLeft-quota ellipse">满{{ prize.quota }}元可用</div>
            </div>
          </template>

          <div class="share-coupon-info">
            <div class="cricle-line"></div>
            <div class="coupon-info">
              <p v-if="!isCmc" class="coupon-price-box">
                <span class="coupon-price">{{prize.discount}}</span>
                <span>元（满{{prize.quota}}元可用）</span>
              </p>
              <template>
                <p class="coupon-desc ellipse" v-if="isCmc">
                  {{ prize.desc }}
                  <!-- {{couponType === 0 ? prize.desc : prize.desc.substring(4,prize.desc.length-2)+'部分商品'}} -->
                </p>
                <p class="coupon-desc ellipse" v-if="!isCmc">
                  {{ couponType === 1 ? `${prize.desc.slice(0, prize.desc.length - 2)}部分商品` : prize.desc.substring(4,prize.desc.length-2) }}
                  <!-- {{couponType === 0 ? prize.desc : prize.desc.substring(4,prize.desc.length-2)+'部分商品'}} -->
                </p>
              </template>

              <p class="coupon-time ellipse" :style="{'margin-top':isCmc && '10px'}">
                <template v-if="!!prize.expireType && prize.expireType === 5">用券时间：</template>
                <template v-else>领取时间：</template>
                {{prize.prizeStartTime | timeFormat}}-{{prize.prizeEndTime | timeFormat}}
              </p>
            </div>
          </div>
          <!-- 已领取 -->
          <img v-if="code === 201" src="@/assets/img/has-coupon-icon.png" srcset="@/assets/img/has-coupon-icon@2x.png 2x,@/assets/img/has-coupon-icon@3x.png 3x" alt="" class="has-get-coupon">

        </div>
        <template v-if="!isCmc">
          <p class="invite-tip" v-if="isMain">好友将获得
            <span>满{{childPrize.quota}}减{{childPrize.discount}}</span>
          </p>
          <p class="invite-tip" v-else-if="code !== 201">点击领取后您和好友均有机会获得优惠券</p>
        </template>
        <template v-else>
          <div class="invite-tip-cmc">
            好友将获得<span>满{{childPrize.quota}}减{{childPrize.discount}}</span>
          </div>

        </template>

        <!-- 子券进度 -->
        <div v-if="isMain === false && code !== 201 && childCouponRate != 0" class="coupon-rate-box">
          <span class="coupon-tip-text">剩余数量</span>
          <div class="coupon-rate">
            <div class="coupon-progress" :style="`width: ${childCouponRate}%`"></div>
          </div>
          <span class="coupon-tip-text">{{childCouponRate}}%</span>
        </div>

        <ul class="share-invited" v-if="isMain">
          <li v-for="(item,index) in sharePersonCount" :key="index">
            <img v-if="index < userList.length" :src="userList[index].profileUrl || '//img20.360buyimg.com/da/jfs/t1/72385/5/11318/1427/5d8a0e47E4f90f504/36671afa85e2cffc.png'" width="36px" height="36px" class="has-border">
            <img v-else src="@/assets/img/invited.png" @click="shareAct"
              srcset="@/assets/img/invited@2x.png 2x,@/assets/img/invited@3x.png 3x">
          </li>
        </ul>

        <!-- 活动进行中 & 会员裂变券协议须知 -->
        <div v-if="showVipRule" class="vip-open-rule-box">
          <span class="read-icon" :class="{active: hasReadRule}" @click="readRule"></span>
          <p>确认授权即同意<span class="link" @click="openVipRule('author')">《会员授权协议》</span>及本店<span class="link" @click="openVipRule('open')">《开卡须知》</span></p>
        </div>

        <div v-if="actStatus === -1"></div>
        <div v-else-if="actStatus === 0" class="share-invited-btn no-start" @click="shareAct">即将开始</div>
        <div v-else-if="actStatus === 2" class="share-invited-btn end" @click="shareAct">活动已结束</div>
        <div v-else-if="code === 201" class="share-invited-btn animated infinite doublePulse" :class="{mt30: isMain === false}" @click="shareAct">{{ finishWord }}</div>
        <div v-else-if="isMain" :class="{mt30: isMain === false}" class="share-invited-btn animated infinite doublePulse" @click="shareAct">
          <template v-if="userList.length === 0">
            <span v-if="modelIds === -4 && !isVip">授权开卡喊好友领券</span>
            <span v-else>喊好友领券</span>
          </template>
          <template v-else-if="ratePerson != 0">
            仅差{{ratePerson}}人 继续加油
          </template>
          <template v-else>
            优惠券发放中
          </template>
        </div>
        <div v-else-if="!isMain" class="share-invited-btn animated infinite doublePulse" :class="{mt30: childCouponRate === 0}" @click="shareAct">
          <template v-if="childCouponRate === 0">
            我要领大额券
          </template>
          <template v-else>
            <span v-if="modelIds === -4 && !isVip">授权开卡</span>立即领取
          </template>
        </div>

        <p v-if="isMain === true && endTime > 0 && tipActTime != '00 : 00 : 00'" class="act-time-count"><span>{{tipActTime}}</span>后结束</p>

      </div>
    </article>

    <SKU
      v-if="code !== 402 && couponType !== undefined"
      :coupon-type="couponType"
      :invite-id="inviteId"
      :prize="prize" />

    <Coupon
      v-if="code !== 0 && code === 402"
      :style="{paddingTop:code === 402 && '3%'}"/>

  </section>
</template>

<script>
// @ is an alias to /src
import Coupon from "@/components/home/Coupon"
import SKU from "@/components/home/SKU"
import Util from "@/utils/utils"
import { isApp } from '@jmfe/jm-common';
// Color API迁移：引入Color网关标准请求方法
// fetchColorGet: 封装的Color网关请求函数，用于主页面的API调用迁移
import {fetchColorGet} from "@/plugins/axiosColor";

// 倒计时计时器
let timer = 0
export default {
  name: 'home',
  components: {
    Coupon,
    SKU
  },
  data () {
    return {
      isFollow: false,
      isCmc: false,
      diabled: false,
      inviteId: '',
      isMain: undefined,//是否为主态
      prizeList: [],
      shareId: '',
      userList: [],
      sharePersonCount: 0,
      couponType: undefined,
      pictureLink: '',
      shopIndex: '',
      mainPerson: {},
      code: 0, //201 已经领取过 402 活动失效(库存没)
      collectList: [],
      startTime: -1,//活动开始时间
      endTime: -1, //活动结束时间
      tipActTime: '00 : 00 : 00', //倒计时显示
      endType: 0,//判断h5是在哪个端打开的
      modelIds: -2, // 券人群类型  -2: 普通裂变券 -4：会员裂变券
      isVip: false, // 是否是店铺会员
      hasReadRule: false, // 是否勾选协议
      finishWord: '进店使用', // 领取完毕后的跳转按钮文案
      openJKL: false // 是否开启京口令
    }
  },
  computed: {
    floorPrize () {
      return {
        desc: "",
        discount: 0,
        prizeEndTime: Date.now(),
        prizeId: 140186695,
        prizeLevel: 0,
        prizeStartTime: Date.now(),
        prizeType: 1,
        quota: 0,
        sharePersonCount: 1,
        validateDay: 1,
      }
    },
    prize () {
      if (this.code === 201) {//已领取过此券
        return this.collectList.length === 0 ? this.floorPrize : this.collectList[0]
      } else {
        return this.prizeList.length === 0 ? this.floorPrize : this.prizeList.filter(item => { return this.isMain ? item.prizeLevel === 0 : item.prizeLevel === 1 })[0]
      }
    },
    childPrize () {
      return this.prizeList.filter(item => item.prizeLevel === 1)[0]
    },
    isGet () {
      return this.isMain ? this.code === 201 : this.collectList.length > 0
    },
    actStatus() {//活动状态
      // 0 活动未开始  1 活动进行中  2 活动结束
      if(this.startTime === -1 || this.endTime === -1) {
        return -1
      } else {
        if(this.startTime > Date.now()) {
          return 0
        } else if(this.endTime < Date.now()) {
          return 2
        } else {
          return 1
        }
      }
    },
    childCouponRate() {//子券领取进度
      let progress = 100
      if(this.userList.length - 1 > 0) {
        progress = ((this.sharePersonCount + 1 - this.userList.length )/this.sharePersonCount).toFixed(2) * 100
        progress = progress > 100 ? 100 : progress
        progress = progress < 0 ? 0 : progress
      }
      if(this.code === 403030010 || this.code === 405000003) {
        progress = 0
      }

      // 当前子券已发光
      if(this.isMain === false && progress === 0 && this.code !== 201 && this.code !== 402 && this.code !== 403030010 && this.code !== 405000003) {
        this.$myToast({
          class: 'FailGetCoupon',
          event: this.toShare,
          other: this.prize //传入优惠券等信息
        });
      }
      return progress
    },
    ratePerson() {
      let rateNum = this.sharePersonCount - this.userList.length
      rateNum < 0 ? 1 : rateNum
      return rateNum
    },
    // 判断渠道
    channel() {
      // 1 PC 2 京东app 5 微信 6 QQ 10 小程序  15 微博
      const channelType = {
        'jd': 2,
        'wx': 5,
        'qq': 6,
        'weibo': 15,
        'mp': 10,
        'jdlittle': 11,
        'pc': 1
      }
      const channelList = ['jd', 'wx', 'qq', 'weibo', 'mp', 'jdlittle']
      let res = channelList.filter(item => isApp(item))
      let channel = res && res.length > 0 ? res[0] : 'pc'
      return channelType[channel] ? channelType[channel] : 1
    },
    // url场景值获取
    scene() {
      const scene = this.getQueryString('scene')
      return scene ? scene : ''
    },
    // 是否展示协议
    showVipRule() {
      let show = false
      if(this.modelIds === -4 && !this.isVip) {
        show = true
      }
      // 主客已领券 || 子态券已发完
      if(this.code === 201 || this.childCouponRate === 0) {
        show = false
      }
      return show
    }
  },
  methods: {
    openPage () {
      let param = {
        inviteId: this.inviteId,
        shareId: this.shareId,
        endType: this.endType,
        channel: this.channel,
        scene: this.scene
      }
      this.$loading.open({ type: 'spinner' });
      // fetchColorGet: Color网关请求方法，自动处理参数格式化和统一错误处理
      // this.$axios.post: 原有网关请求方法，保持向下兼容性
      const request = fetchColorGet('interact_share_fission_open_page', param)
      return request.then(res => {
        this.$loading.close()
        this.setData(res)
        this.bury("share_coupon_1571229562021|1", JSON.stringify(this.$data))
      }).catch(res => {
        this.$loading.close()
        this.bury("share_coupon_1571229562021|3", JSON.stringify(res))
        this.code = res.code
        if (res.code === 201) {
          this.collectList = res.data.collectList
          this.setData(res.data)
        } else if (res.code === 402) {
          this.$toast({
            iconName: 'warning',
            msg: '很遗憾，活动已结束，看看更多神券吧！'
          })
        } else if(res.code === 402020005 || res.code === 405000001) {
          this.$loading.close()
          this.$myToast({
            class: 'CommonErr',
            event: this.toUse//进店使用
          });
        } else {
          if(res.code === 405000003) this.code = 402
          this.$loading.close()
          this.$toast({
            iconName: 'warning',
            msg: res.message
          })
        }
      });
    },
    setData (res) {
      this.isMain = res.mainPage
      this.prizeList = res.prizeList
      if (!this.shareId) {
        this.shareId = res.shareId
      }
      this.userList = res.userList
      this.sharePersonCount = res.sharePersonCount
      this.couponType = res.couponType
      this.shopIndex = res.shopIndex
      this.pictureLink = res.pictureLink || ''
      this.mainPerson = res.mainPerson
      this.startTime = res.startTime || Date.now()
      this.endTime = res.endTime || Date.now()
      this.showTime()
      this.isCmc = res.sourceName === 'CMC'
      this.modelIds = typeof res.modelIds !== 'undefined' ? Number(res.modelIds) : -2// 券人群类型
      this.isVip = typeof res.inPersonModel !== 'undefined' ? res.inPersonModel : false// 是否是会员用户
      // 如果是会员券
      if(this.modelIds === -4) {
        document.title = '领会员专属神券'
      }
      // 如果是品类券
      if(res.sourceName === 'CMC') {
        document.title = '专属神券免费领'
        this.finishWord = '去使用'
      }
    },
    showTime() {
      if(this.endTime != -1 && this.endTime > 0) {
        let suprlusTime = (this.endTime - new Date().getTime()) / 86400000
        if(suprlusTime < 1) {
          this.countTime()
          timer = setInterval(() => {
            this.countTime()
          }, 1000)
        }
      }
    },
    countTime() {
      let end = this.endTime || Date.now(),
          now = Date.now(),// 获取当前时间
          offset = Math.floor((end - now) / 1000),// 计算差值
          tipActTime = '00 : 00 : 00'

      let sec = offset % 60
      let min = Math.floor(offset / 60) % 60
      let hour = Math.floor(offset / 60 / 60) % 24

      sec = (sec > 0 && sec < 10 ) ? '0' + sec : (sec > 0 ? sec : '00')
      min = (min > 0 && min < 10 ) ? '0' + min : (min > 0 ? min : '00')
      hour = (hour > 0 && hour < 10 ) ? '0' + hour : (hour > 0 ? hour : '00')

      tipActTime = `${hour} : ${min} : ${sec}`
      this.tipActTime = tipActTime

      if (offset <= 0) {
        this.code = 402
        //活动失效
        this.$toast({
          iconName: 'warning',
          msg: '很遗憾，活动已结束，看看更多神券吧！'
        })
        clearInterval(timer)
        return
      }
    },
    changeFollow () {
      this.isFollow = !this.isFollow;
      this.bury("share_coupon_1571229562021|4", JSON.stringify(this.$data))
    },
    shareAct () {
      let that = this;
      //加锁
      if (this.disabled) {
        return;
      }
      if (this.actStatus === 0) {
        this.$toast({
          iconName: 'warning',
          msg: '活动暂未开始，请耐心等待！'
        })
        this.bury("share_coupon_1571229562021|5", JSON.stringify(this.$data))
        return;
      }

      if (this.actStatus === 2) {
        this.$toast({
          iconName: 'warning',
          msg: '很遗憾，活动已结束，看看更多神券吧'
        })
        this.bury("share_coupon_1571229562021|5", JSON.stringify(this.$data))
        return;
      }

      let param = {
        inviteId: this.inviteId,
        follow: this.isFollow,
        shareId: this.shareId,
        mainPage: this.isMain,
        channel: this.channel,
        scene: this.scene
      }
      this.disabled = true
      if (this.code !== 201) {
        // 如果是会员裂变券 & 不是会员 => 先加入会员
        if(this.modelIds === -4 && !this.isVip) {
          if(this.hasReadRule) {
            this.joinVip()
            return;
          } else {
            this.$toast({
              iconName: 'warning',
              msg: '请先勾选相关协议~'
            })
            this.disabled = false;
            return;
          }
        }
        if (this.isMain) {
          //主态
          // 邀请人数已达上限 - 托底
          if(this.ratePerson == 0) {
            this.disabled = false;
            return
          }
          var isJdAPP = /jdapp/i.test(navigator.userAgent.toLowerCase());
          const scene = this.scene ? `&scene=${this.scene}` : ''
          let url = location.origin + location.pathname + `?inviteId=` + that.inviteId + "&shareId=" + that.shareId + scene;
          if (!isJdAPP) {
            //判断是不是在微信小程序环境里，是的话直接调用京东购物小程序分享
            // eslint-disable-next-line no-undef
            if(JD && JD.wxappext && JD.wxappext.isWxapp) {
              // eslint-disable-next-line no-undef
              JD.wxappext.isWxapp(function(iswxapp){
                // eslint-disable-next-line no-undef
                if(iswxapp && (JD.wxappext.wxappType == 2 || JD.wxappext.wxappType == 1 || JD.wxappext.wxappType ==0)){
                  const atmosimgurl = encodeURIComponent('https://img20.360buyimg.com/da/jfs/t1/100222/9/17097/271221/5e819228Ed5309504/8668b9fd376e4cb7.png');
                  const sharetitle = encodeURIComponent('送你一张店铺神券，速领手慢无！');
                  const shareurl = encodeURIComponent(url);
                  const shareimgurl = encodeURIComponent(`https://img20.360buyimg.com/da/jfs/t1/118685/28/2165/235125/5e9fea55E3f9f226d/61fb3551d634a41a.png`);
                  const posterdesc = encodeURIComponent('快来领券一起买买买吧！');
                  const postertitle = encodeURIComponent(`送你一张${that.prizeList.length === 0 ? that.prize.desc : that.prize.desc.substring(4,that.prize.desc.length-2)}店铺专属神券，速领手慢无！`);
                  const posterimgurl = encodeURIComponent(`https://img20.360buyimg.com/da/jfs/t1/97195/17/17019/235125/5e81929dE575744b1/51e9e223c57c4a13.png`);
                  const posterbtnptag = '138691.9.3';
                  const pvptag = '138691.9.2';
                  const saveposterptag = '138691.9.4'
                  const sharebtnptag = '138691.9.1';
                  const shareposter = 1;
                  const noneBtnBg = 1;
                  let shareApi = fetchColorGet("interact_share_fission_share", param)
                  shareApi.then(() => {
                    let param2 = `atmosimgurl=${atmosimgurl}&sharetitle=${sharetitle}&shareurl=${shareurl}&shareimgurl=${shareimgurl}&postertitle=${postertitle}&posterdesc=${posterdesc}&posterimgurl=${posterimgurl}&posterbtnptag=${posterbtnptag}&pvptag=${pvptag}&saveposterptag=${saveposterptag}&sharebtnptag=${sharebtnptag}&shareposter=${shareposter}&noneBtnBg=${noneBtnBg}`;
                    that.disabled = false;
                    // eslint-disable-next-line no-undef
                    JD.wxappext.goto('/pages/h5share/index/index' + '?'+param2);
                    that.bury("share_coupon_1571229562021|15", JSON.stringify(that.$data))

                  }).catch(() => {
                    that.disabled = false;
                  });

                } else {
                  let u = navigator.userAgent;
                  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                  let mpath = ''
                  if (isAndroid) {
                    mpath = `/pages/h5/index?encode_url=${encodeURIComponent(url)}`
                  } else if (isiOS) {
                    mpath = `/pages/h5/index?encode_url=${encodeURIComponent(encodeURIComponent(url))}`
                  } else {
                    mpath = `/pages/h5/index?encode_url=${encodeURIComponent(url)}`
                  }

                  //如果是在拼购app里打开
                  if(/jdpingou/i.test(navigator.userAgent.toLowerCase())){
                    let shareApi = fetchColorGet("interact_share_fission_share", param)
                    shareApi.then(() => {
                      that.disabled = false;
                      // eslint-disable-next-line no-undef
                      JSSDK.WebView.callSharePanel({
                        title: "送你一张店铺神券，速领手慢无！",
                        content: "快来领券一起买买买吧",
                        shareUrl: url,
                        channel: "Wxfriends",
                        iconUrl: "http://misc.360buyimg.com/lib/img/e/logo-201305.png",
                        mpId: "gh_d227644b6f7c", // 小程序appId
                        mpIconUrl: "https://img20.360buyimg.com/da/jfs/t1/118685/28/2165/235125/5e9fea55E3f9f226d/61fb3551d634a41a.png", // 分享的图（200 * 160）
                        mpPath: mpath, // 打开的小程序路径，可以带参
                      });
                      that.bury("share_coupon_1571229562021|16", JSON.stringify(that.$data))
                    }).catch(() => {
                      that.disabled = false;
                    });

                  }else {
                    //非京东APP情况，会先打开APP再分享
                    that.disabled = false;
                    Util.openJDAPP();
                    that.bury("share_coupon_1571229562021|6", JSON.stringify(that.$data))
                    return;
                   }
                }
              });
            } else {
              //非京东APP情况，会先打开APP再分享
              that.disabled = false;
              Util.openJDAPP();
              that.bury("share_coupon_1571229562021|6", JSON.stringify(that.$data))
              return;
            }
          }else {
            let shareApi = fetchColorGet("interact_share_fission_share", param)
            shareApi.then(() => {
              this.disabled = false;
              //京东APP内部调用分享功能
              Util.callShare(this.prize.desc, this.inviteId, this.shareId, this.scene, this.openJKL)
            }).catch(() => {
              this.disabled = false;
              //   this.$myToast({
              //     class: 'FailShare'
              //   });

              this.$myToast({
                class: 'CommonErr',
                event: this.toUse//进店使用
              });
            });
            this.bury("share_coupon_1571229562021|7", JSON.stringify(this.$data))
          }
        } else {
          //客态
          // 券已领完
          if(this.childCouponRate === 0) {
            this.disabled = false;
            this.toShare()
          } else {
            const addShareApi = fetchColorGet("interact_share_fission_addShare", param)
            addShareApi.then(() => {
              this.disabled = false;
              this.openPage();
              this.$myToast({
                class: 'SuccessReceive',
                event: this.toShare,
                other: this.prize //传入优惠券等信息
              });
            }).catch(res => {
              this.disabled = false;
              if (res.code == 403030010 ) {
                //403030010 对不起，该分享人数已经满了
                this.code = res.code
                // this.$myToast({
                //   class: 'FailReceive',
                //   event: this.toShare
                // });
                this.$myToast({
                  class: 'FailGetCoupon',
                  event: this.toShare,
                  other: this.prize //传入优惠券等信息
                });
              } else if(res.code == 405000003) {
                // 当前活动奖项库存被领完
                this.$myToast({
                  class: 'FailReceive'
                });
              } else if(res.code === 402020005 || res.code === 405000001) {
                this.$myToast({
                  class: 'CommonErr',
                  event: this.toUse//进店使用
                });
              } else {
                this.$toast({
                  iconName: 'warning',
                  msg: res.message
                })
              }
            });
          }
          this.bury("share_coupon_1571229562021|8", JSON.stringify(this.$data))
        }
      } else {
        this.disabled = false
        this.bury("share_coupon_1571229562021|9", JSON.stringify(this.$data))
        this.toUse();
      }
    },
    async checkOutEnviroment() {
      let that = this;
      var isJdAPP = /jdapp/i.test(navigator.userAgent.toLowerCase());
      var isPinGouApp =  /jdpingou/i.test(navigator.userAgent.toLowerCase())
      return new Promise(resolve => {
        if (isJdAPP) {//京东app
          that.endType = 1;
          resolve(1)
        } else if(isPinGouApp){//京喜app
          that.endType = 2;
          resolve(1)
        }else {
          // eslint-disable-next-line no-undef
          if(JD && JD.wxappext && JD.wxappext.isWxapp) {
            // eslint-disable-next-line no-undef
            JD.wxappext.isWxapp(function (iswxapp) {
              if (iswxapp) {
                // eslint-disable-next-line no-undef
                if(JD.wxappext.wxappType == 2){//京喜小程序
                  that.endType = 2;
                  // eslint-disable-next-line no-undef
                }else if(JD.wxappext.wxappType == 0 || JD.wxappext.wxappType == 1) {
                  that.endType = 1;
                } else {
                  that.endType = 0;
                }
              }else {
                that.endType = 0;
              }
              resolve(1)
            })
          }else {
            that.endType = 0;
            resolve(1)
          }
        }
      });

    },
    random () {
      return ('000000' + Math.floor(Math.random() * 999999)).slice(-6)
    },
    toShare () {
      this.bury("share_coupon_1571229562021|10", JSON.stringify(this.$data))
      const scene = this.scene ? `&scene=${this.scene}` : ''
      location.href = location.origin + location.pathname + `?inviteId=` + this.inviteId + scene;
    },
    toUse () {
      this.bury("share_coupon_1571229562021|11", JSON.stringify(this.$data))
      // 商品 & 店铺均去店铺首页
      if (this.shopIndex && this.shopIndex.length != 0) {
        location.href = this.shopIndex;
      } else {
        location.href = '//m.jd.com'
        // location.href = `https://so.m.jd.com/list/couponSearch.action?ptag=37070.3.2&couponbatch=${this.prize.prizeId}&coupon_shopid=0`
      }
    },
    openRule () {
      this.bury("share_coupon_1571229562021|2")
      this.$myToast({
        class: 'RuleToast',
        other: {
          modelIds: this.modelIds,
          isVip: this.isVip
        }
      });
    },
    watchOrientation () {
      if (window.orientation == 90 || window.orientation == -90) {
        this.$toast({
          iconName: 'warning',
          msg: '横屏显示异常，请竖屏查看！'
        })
        return false
      }
    },
    // 勾选协议
    readRule() {
      this.bury("share_coupon_1571229562021|20")
      this.hasReadRule = !this.hasReadRule
    },
    // 加入会员
    joinVip() {
      this.bury("share_coupon_1571229562021|21")
      let bindCardApi = fetchColorGet("interact_share_fission_bindCards", {inviteId: this.inviteId})
      bindCardApi.then(() => {
        this.bury("share_coupon_1571229562021|22")
        this.isVip = true
        this.disabled = false;
        this.shareAct()
      }).catch((res) => {
        this.bury("share_coupon_1571229562021|23")
        this.disabled = false;
        this.$myToast({
          class: 'OpenCardErr',
          other: res.message || '啊哦，开卡失败了呢'
        });
      });
    },
    // 打开会员协议
    openVipRule(type) {
      this.bury("share_coupon_1571229562021|24")
      this.$router.push({path: '/vipRule', query: {type: type, inviteId: this.inviteId}})
    },
    // 是否开启京口令
    getOpenJKL() {
      const shareTypeApi = fetchColorGet("interact_share_fission_getShareType")
      shareTypeApi.then((res) => {
        this.openJKL = res
      }).catch(() => {
        this.openJKL = false
      });
    }
  },
  async created () {
    this.inviteId = this.getQueryString('inviteId');
    this.shareId = this.getQueryString('shareId');
    this.watchOrientation();
    await this.checkOutEnviroment();
    await this.openPage();
    await this.getOpenJKL();
    this.$nextTick(() => {
      if (this.getQueryString('event')) {
        setTimeout(() => {
          this.shareAct();
        },300)
      }
    })
  },
  destroyed() {
    clearInterval(timer)
  }
}

</script>
<style lang="scss" scoped>
.share {
  .red {
    color: #f33;
  }
  .share-main {
    position: relative;
    width: 100%;
    padding-top: 99px;
    background-image: url("./../assets/img/top-banner.png");
    background: -webkit-image-set(
      url("./../assets/img/top-banner.png") 1x,
      url("./../assets/img/top-banner@2x.png") 2x,
      url("./../assets/img/top-banner@3x.png") 3x
    );
    background-size: 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    &.share-vip {
      background-image: url("./../assets/img/top-banner-vip.png");
      background: -webkit-image-set(
        url("./../assets/img/top-banner-vip.png") 1x,
        url("./../assets/img/top-banner-vip@2x.png") 2x,
        url("./../assets/img/top-banner-vip@3x.png") 3x
      );
      background-size: 100%;
      background-repeat: no-repeat;
      box-sizing: border-box;
    }

    .share-main-icon {
      position: absolute;
      left: 0;
      top: 60px;
      width: 43px;
      height: 58px;
      background-image: url("./../assets/img/coupon-icon.png");
      background: -webkit-image-set(
        url("./../assets/img/coupon-icon.png") 1x,
        url("./../assets/img/coupon-icon@2x.png") 2x,
        url("./../assets/img/coupon-icon@3x.png") 3x
      );
      background-size: 100%;
      background-repeat: no-repeat;
      z-index: 1;
    }

    &-disable {
      padding-top: 15px;
      background-image: url("./../assets/img/top-banner-visite.png");
      background: -webkit-image-set(
        url("./../assets/img/top-banner-visite.png") 1x,
        url("./../assets/img/top-banner-visite@2x.png") 2x,
        url("./../assets/img/top-banner-visite@3x.png") 3x
      );
      background-size: 100%;
      background-repeat: no-repeat;
      box-sizing: border-box;
    }

    .share-standby {
      min-height: 84px;
      .user-info {
        margin-bottom: 10px;
        display: flex;
        width: 100%;
        height: 36px;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
        justify-content: center;
        img {
          border-radius: 50%;
        }
        span {
          margin-left: 10px;
          font-weight: 600;
        }
      }
      .big-tip {
        margin-bottom: 10px;
        font-size: 24px;
        color: #ffccb1;
        line-height: 24px;
        text-align: center;
        font-weight: 500;
      }
      .tip {
        font-size: 14px;
        color: #ffccb1;
        line-height: 14px;
        text-align: center;
        &.big-line {
          line-height: 20px;
        }
      }
    }

    .share-coupon {
      margin: 0 auto;
      padding: 20px;
      width: 355px;
      background-image: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 45%);
      box-shadow: 0 2px 20px 0 rgba(251,80,58,0.30);
      border-radius: 12px;
      font-size: 12px;
      color: #666666;
      box-sizing: border-box;

      .share-top-box {
        position: relative;
        margin-bottom: 15px;
        .share-invitenum-tip {
          line-height: 12px;
        }
        .share-rule {
          position: absolute;
          right: 0px;
          top: -5px;
          width: 40px;
          height: 22px;
          font-size: 10px;
          // transform: scale(0.84);
          // transform-origin: 0% 0%;
          color: #FFFFFF;
          line-height: 22px;
          font-weight: 500;
          background-image: linear-gradient(180deg, #D7D7D7 0%, #C7C7C7 100%);
          border-radius: 15.5px;
          text-align: center;
        }
         .share-rule-cmc {
          position: absolute;
          right: 0px;
          top: -5px;
          width: 40px;
          height: 22px;
          font-size: 10px;
          transform: scale(0.84);
          transform-origin: 0% 0%;
          color: #FFFFFF;
          line-height: 22px;
          background-image: linear-gradient(360deg, #999999 0%, #C7C7C7 100%);
          border-radius: 100px;
          text-align: center;
        }
      }

      .share-coupon-box {
        position: relative;
        display: flex;
        padding: 15px;
        width: 315px;
        height: 100px;
        background-image: linear-gradient(180deg, #FFD3CB 0%, #FFE9E5 98%);
        border-radius: 6px 8px;
        box-sizing: border-box;
        overflow: hidden;

        .coupon-get-icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 50px;
          height: 50px;
          img {
            width: 50px;
            height: 50px;
          }
        }

        .coupon-trangle {
          position: absolute;
          bottom: -12px;
          width: 50px;
          height: 50px;
          background-image: url("./../assets/img/coupon-trangle.png");
          background: -webkit-image-set(
            url("./../assets/img/coupon-trangle.png") 1x,
            url("./../assets/img/coupon-trangle@2x.png") 2x,
            url("./../assets/img/coupon-trangle@3x.png") 3x
          );
          background-size: 100%;
          background-repeat: no-repeat;
          z-index: 1;
          &.left {
            left: -10px;
          }
          &.right {
            right: -10px;
            transform: scaleX(-1);
          }
        }

        .share-shop-logo {
          margin-right: 15px;
          width: 70px;
          height: 70px;
          border-radius: 4px;
          box-sizing: border-box;
          background-color: #fff;
          &.has-logo {
            object-fit: scale-down;
          }
        }

        .share-coupon-info {
          display: flex;
          .cricle-line {
            position: relative;
            top: -15px;
            height: 100px;
            border-left: 1px dashed #fff;
            &:before ,
            &:after {
              content: " ";
              display: block;
              position: absolute;
              left: -8px;
              width: 14px;
              height: 14px;
              background: #fff;
              border-radius: 50%;
            }
            &:before {
              top: -7px;
            }
            &:after {
              bottom: -7px;
            }
          }

          .coupon-info {
            padding-left: 15px;
            font-size: 12px;
            color: #FF2818;
            line-height: 12px;
            .coupon-price-box {
              display: flex;
              height: 30px;
              line-height: 30px;
              align-items: baseline;
              .coupon-price {
                font-size: 30px;
                font-family: DINAlternate-Bold;
              }
            }
            .coupon-desc {
              margin-top: 8px;
            }
            .coupon-time {
              margin-top: 8px;
              font-size: 12px;
              transform: scale(0.84);
              transform-origin: 0% 0%;
              color: rgba(255,40,24,0.6);
            }
          }
        }

        .coupon-cmc{
          display: flex;
          width: 100%;
          box-sizing: border-box;
          padding: 7px 0 0 5px;
          flex-direction: column;
        }

        .coupon-cmcLeft {
          display: flex;
          box-sizing: border-box;
          padding: 0 15px 0 0;
          width: 100%;
          flex-direction: column;
          color: #FF2818;
        }

        .coupon-cmcLeft-discount {
          >span{
            font-size: 20px;
            margin-right: 2.5px;
          }
          font-size: 36px;
          font-weight: bold;
          margin-bottom: 10px;
          line-height: 30px;
          min-width: 55px;
          height: 30px;
        }

        .coupon-cmcLeft-quota {
          font-size: 12px;
          transform: scale(.8);
          transform-origin: left top;
          line-height: 12px;
          color: #FF2818;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .has-get-coupon {
          position: absolute;
          right: 20px;
          bottom: 0px;
          width: 60px;
          height: 46px;
        }
      }

      .coupon-rate-box {
        margin-top: 15px;
        margin-bottom: 17px;
        width: 100%;
        display: flex;
        font-size: 12px;
        color: #FF2717;
        line-height: 12px;
        justify-content: space-around;
        align-items: center;

        .coupon-rate {
          margin: 0 14px;
          flex: 1;
          height: 8px;
          background: rgba(255,39,23,0.10);
          border-radius: 8px;
          .coupon-progress {
            height: 8px;
            background-image: linear-gradient(-45deg, #FF2717 35.5%, rgba(255,39,23,0.4) 35.5%, rgba(255,39,23,0.4) 50%, #FF2717 50%, #FF2717 85.5%, rgba(255,39,23,0.4) 85.5%, rgba(255,39,23,0.4) 100%);
            background-size: 10px 10px;
            border-radius: 8px;
          }
        }


      }

      .invite-tip {
        margin-top: 8px;
        display: flex;
        font-size: 12px;
        color: #666666;
        line-height: 12px;
        span {
          display: block;
          padding: 2px 5px;
          position: relative;
          bottom: 1px;
          margin-left: 5px;
          color: #fff;
          font-size: 12px;
          transform: scale(0.84);
          transform-origin: 0% 0%;
          background: #FF5224;
          border-radius: 3px;
        }
      }

      .invite-tip-cmc {
        margin-top: 10px;
        display: flex;
        font-size: 12px;
        color: #666666;
        line-height: 12px;
        span {
          position: relative;
          bottom: 1px;
          display: block;
          padding: 2px 5px;
          margin-left: 5px;
          color: #fff;
          font-size: 12px;
          transform: scale(0.84);
          transform-origin: 0% 0%;
          background: #FF5224;
          border-radius: 3px;
          box-sizing: border-box;
        }
      }

      .vip-open-rule-box {
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #666666;
        line-height: 16px;
        .read-icon {
          margin-right: 5px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 2px solid #dcdcdc;
          transition: background .2s;
          box-sizing: border-box;
          cursor: pointer;
          &.active {
            text-align: center;
            border-color: #4d80f0;
            &::after {
              content: "";
              margin: 1px auto;
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #4d80f0;
            }
          }
        }
        .link {
          color: #4d80f0;
          text-decoration: none;
        }
      }

      .share__couponName {
        width: 70px;
        height: 70px;
        margin-left: 50px;
        margin-top: 25px;
      }
      .share__info {
        margin-top: -70px;
        margin-left: 150px;
        .share__couponDetail {
          color: #ffffff;
        }
        .share__desc {
          color: #ffffff;
          margin: 8px 0 8px;
        }
        .share__price {
          font-family: DINAlternate-Bold;
          font-size: 30px;
          line-height: 30px;
        }
        .share__time {
          opacity: 0.6;
          font-size: 12px;
          transform: scale(0.84);
          transform-origin: 0% 0%;
          color: #ffffff;
          line-height: 12px;
        }
      }
      .share-invited {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        // width: 90%;
        margin: 10px auto;
        li {
          display: inline-block;
          margin: 5px 10px;
          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            box-sizing: border-box;
            &.has-border {
              border: 1px dotted #FF5224;
            }
          }
        }
        // li:nth-last-child(5):first-child,
        // li:nth-last-child(5):first-child ~ li {
        //   margin: 10px px;
        // }
        // li:nth-last-child(10):first-child,
        // li:nth-last-child(10):first-child ~ li {
        //   margin: 1px 15px;
        // }
      }
      .share-invited-btn {
        position: relative;
        margin: 6px auto 0;
        width: 220px;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        background-image: url("./../assets/img/going.png");
        background: -webkit-image-set(
          url("./../assets/img/going.png") 1x,
          url("./../assets/img/going@2x.png") 2x,
          url("./../assets/img/going@3x.png") 3x
        );
        background-size: 100%;
        background-repeat: no-repeat;
        &.no-start {
          background-image: url("./../assets/img/unstart.png");
          background: -webkit-image-set(
            url("./../assets/img/unstart.png") 1x,
            url("./../assets/img/unstart@2x.png") 2x,
            url("./../assets/img/unstart@3x.png") 3x
          );
          background-size: 100%;
          background-repeat: no-repeat;
        }
        &.end {
          margin-top: 30px;
          background-image: url("./../assets/img/over.png");
          background: -webkit-image-set(
            url("./../assets/img/over.png") 1x,
            url("./../assets/img/over@2x.png") 2x,
            url("./../assets/img/over@3x.png") 3x
          );
          background-size: 100%;
          background-repeat: no-repeat;
        }
        &.mt30 {
          margin-top: 30px;
        }
      }

      .act-time-count {
        margin-top: 12px;
        display: flex;
        font-size: 12px;
        color: #999999;
        line-height: 12px;
        text-align: center;
        justify-content: center;
        span {
          color: #FF311C;
          font-family: DINAlternate-Bold;
        }
      }

      .share__follow {
        overflow: visible;
        text-align: center;
        margin-top: 10px;
      }
      .share__followContent {
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
.jm-loading {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1;
  .jm-loading__wrap {
    background-color: none;
  }
}
.title {
  font-size: 18px;
  color: #666666;
  text-align: center;
  height: 48px;
  line-height: 48px;
  &::before,
  &::after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 17px;
    position: absolute;
    margin-top: 16px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  &::before {
    margin-left: -25.1px;
    background-image: url("./../assets/img/title-before@2x.png");
  }
  &::after {
    background-image: url("./../assets/img/title-after@2x.png");
    // content: url("./../assets/img/title-after@2x.png");
    margin-left: 5.1px;
  }
}
.ellipse {
  text-emphasis: hidden;
  overflow: hidden;
  white-space: nowrap;
}

.animated {
  -webkit-animation-duration: 0s;
  animation-duration: 0s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
@-webkit-keyframes doublePulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes doublePulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.doublePulse {
  -webkit-animation-name: doublePulse;
  animation-name: doublePulse;
  -webkit-animation-duration: 0s;
  animation-duration: 0s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
</style>
